import type { CSSProperties, PropsWithChildren, Ref } from 'react';

/**
 * ScrollAnchor
 * Invisible anchor element that uses CSS `scroll-margin-top` to account for sticky headers.
 */
export interface ScrollAnchorProps extends PropsWithChildren {
  className?: string;
  style?: CSSProperties;
  /** If number provided, treated as pixels */
  offset?: string | number;
  ariaHidden?: boolean;
  ref: Ref<HTMLDivElement | null>;
}

export const ScrollAnchor = ({
  children,
  className = 'h-0',
  style = {},
  offset = '120px',
  ariaHidden = true,
  ref,
}: ScrollAnchorProps) => {
  const scrollMarginTop = typeof offset === 'number' ? `${offset}px` : (offset ?? '0px');

  return (
    <div
      ref={ref}
      className={className}
      style={{ ...style, scrollMarginTop }}
      aria-hidden={ariaHidden}
    >
      {children}
    </div>
  );
};
